module.exports = __webpack_public_path__ + "img/bg_attend.5e6f0b0a.png";